<template>
  <div v-if="company && company.format !== 'PERSONAL' ">
    <div v-if="hasAdmin">
      <div
        v-if="isAdmin"
        class="alert alert-warning"
      >
        {{ $t('userCompanyAdminDetails.sizBuIrktinIdarisisiniz') }}
      </div>
      <div
        v-else-if="companyUserStatus!=='verified'"
        class="alert alert-warning"
      >
        {{ $t('userCompanyAdminDetails.sizinHesabnzIrktinizinPlatformadakIdarisiTrfindnTs') }}
      </div>
    </div>
    <div v-else>
      <div class="alert alert-info">
        {{ $t('userCompanyAdminDetails.buIrktinRsmiCavabdehIdarisiYoxdur') }}
        <button
          class="btn btn-link  text-underline"
          @click="openModal"
        >
          {{ $t('userCompanyAdminDetails.rsmiIdariOlmaqNMracitEt') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>

import {mapState} from "vuex";
import {
  addAdmin, generateOtpCompany, verifyOtpCompanyEmail,
} from "@/repositories/GeneralDataRepository";
import public_emails from '@/repositories/public_emails.json';
import {getErrorCode} from "@/repositories/Utils";

export default {
  name: 'UserCompanyAdminDetails',

  data() {
    return {
      email: '',
      isEmailVerified: false,
    }
  },

  computed: {

    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      isAdmin: state => state.auth.isAdmin,
      hasAdmin: state => state.auth.hasAdmin,
      companyUserStatus: state => state.auth.companyUserStatus,
    })

  },

  methods: {
    openModal() {
      this.promptForEmail()
          .then(email => {
            if (email) return this.generateOtp(email);
          })
          .then(response => {
            if (response) return this.promptForOtp();
          })
          .then(otp => {
            if (otp) return this.verifyOtp(otp);
          })
          .then(response => {
            return this.addAdmin();
          })
          .catch(error => {
            if (error) this.showError(error);
          });
    },
    promptForEmail() {
      return this.$swal.fire({
        title: this.$t("userCompanyAdminDetails.promptForEmailTitle"),
        text: this.$t("userCompanyAdminDetails.promptForEmailText"),
        input: "email",
        inputPlaceholder: this.$t("userCompanyAdminDetails.promptForEmailPlaceholder"),
        inputValidator(value) {
          const domain = value.slice(value.indexOf('@') + 1);
          if (!value) {
            return getErrorCode("errorMail");
          } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            return getErrorCode("formatErrorMail");
          } else if (public_emails.includes(domain)) {
            return getErrorCode("notCorporateEmail");
          }
        },
        icon: 'info',
        confirmButtonText: this.$t("body.gndr"),
      }).then(result => {
        if (result.isConfirmed) {
          this.email = result.value;
          return result.value;
        }
      });
    },

    generateOtp(email) {
      return generateOtpCompany(email, this.token);
    },

    promptForOtp() {
      return this.$swal.fire({
        title: this.$t("newPolRequest.confirm"),
        text: this.$t("userCompanyAdminDetails.promptForOtpText"),
        input: "text",
        inputPlaceholder: this.$t("userCompanyAdminDetails.promptForOtpConfirmCode"),
        icon: 'info',
        confirmButtonText: this.$t("newPolRequest.confirm"),
      }).then(result => {
        if (result.isConfirmed) {
          return result.value;
        }
      });
    },

    verifyOtp(otp) {
      return verifyOtpCompanyEmail(this.email, otp, this.token, this.company.id).then(res => {

        if (res.code !== 1000) {
          throw new Error(this.$t("userCompanyAdminDetails.otpNotCorrect"));
        }
        this.isEmailVerified=true
      });
    },

    addAdmin() {
      if (this.isEmailVerified) {
        return addAdmin(this.user.id, this.company.id, this.token).then(res => {
          console.log("token: ", this.token);
          if (res.code === 1000) {
            return this.$swal.fire({
              title: this.$t("vendorManagementPurchasesReports.uurlu"),
              text: this.$t("userCompanyAdminDetails.elaveEdildi"),
              icon: 'success',
              confirmButtonText: 'OK',
            }).then(() => window.location.reload());
          } else {
            throw new Error(res.message);
          }
        });
      }
    },

    showError(error) {
      return this.$swal.fire({
        title: this.$t("vendorManagementPurchasesReports.uursuz"),
        text: error.message,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  }
}
</script>
